module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/510201fee0eb0012cff8c51de7573726.png";